module.exports = __webpack_public_path__ + "img/img41.9baf30f4.png";